import { helper } from '@ember/component/helper';

import { isSet } from 'rise-ui/utils/nullish.js';

export default helper(function isSetHelper(params, { one }) {
  return params[ one ? 'some' : 'every' ](isSet);
});
